const normalizeText = (value: string) =>
  value
    .toLowerCase()
    .normalize('NFD')
    .replaceAll(/[\u0300-\u036f]/g, '')

const tokenize = (value: string) =>
  normalizeText(value)
    .split(/[^a-z0-9]+/)
    .filter(Boolean)

/** A marca precisa aparecer como sequência inteira de palavras do nome. */
const includesTokens = (haystack: string[], needle: string[]) => {
  if (!needle.length) return false

  return haystack.some((_, index) =>
    needle.every((token, offset) => haystack[index + offset] === token)
  )
}

/**
 * Infere a marca comparando o nome do produto com as marcas cadastradas
 * (por palavra inteira, normalizada; marca mais longa vence em empate).
 */
export const matchBrandByName = (
  name: string,
  brandNames: string[]
): string | null => {
  const haystack = tokenize(name)

  const match = brandNames
    .filter(brand => includesTokens(haystack, tokenize(brand)))
    .sort((a, b) => b.length - a.length)[0]

  return match ?? null
}
